import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { VendorEntity } from './vendor.entity';

@Index('vendor_address__fk_vendor__id_fk', ['fkVendorId'], {})
@Entity('vendor_address')
export class VendorAddressEntity extends BaseEntity {
	@Column('varchar', { name: 'externalId', nullable: true, length: 255 })
	public externalId!: string | null;

	@Column('varchar', { name: 'externalId2', nullable: true, length: 255 })
	public externalId2!: string | null;

	@Column('varchar', { name: 'address1', nullable: true, length: 255 })
	public address1!: string | null;

	@Column('varchar', { name: 'address2', length: 255 })
	public address2!: string;

	@Column('varchar', { name: 'city', length: 255 })
	public city!: string;

	@Column('varchar', { name: 'state', nullable: true, length: 255 })
	public state!: string | null;

	@Column('varchar', { name: 'zip', nullable: true, length: 255 })
	public zip!: string | null;

	@Column('varchar', { name: 'phone', nullable: true, length: 255 })
	public phone!: string | null;

	@Column('varchar', { name: 'email', nullable: true, length: 255 })
	public email!: string | null;

	@Column('varchar', {
		name: 'billFromOrShipFrom',
		nullable: true,
		length: 255,
	})
	public billFromOrShipFrom!: string | null;

	@Column({
		type: 'boolean',
		name: 'isDefaultBillFrom',
		width: 1,
		default: () => "'0'",
	})
	public isDefaultBillFrom!: boolean;

	@Column({
		type: 'boolean',
		name: 'isDefaultShipFrom',
		width: 1,
		default: () => "'0'",
	})
	public isDefaultShipFrom!: boolean;

	@Column({ type: 'boolean', name: 'isMainAddress', width: 1, default: () => "'0'" })
	public isMainAddress!: boolean;

	@Column('int', { name: '_fk_vendor__id', unsigned: true })
	public fkVendorId!: number;

	@ManyToOne(() => VendorEntity, (vendor) => vendor.vendorAddresses, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_vendor__id', referencedColumnName: 'id' }])
	public fkVendor!: VendorEntity;
}
